import { render, staticRenderFns } from "./Cronograma.vue?vue&type=template&id=6d89d7bc&scoped=true"
import script from "./Cronograma.vue?vue&type=script&lang=js"
export * from "./Cronograma.vue?vue&type=script&lang=js"
import style0 from "./Cronograma.vue?vue&type=style&index=0&id=6d89d7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d89d7bc",
  null
  
)

export default component.exports